import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../metrics/MetricCard";
import MetricBarChart from "../charts/MetricBarChart";
import ChartHeader from "../metrics/ChartHeader";

const DemographicMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("Demographic data:", sortedMetrics);

    // Define metrics for order
    const demoOne: DisaggregatedMetric[] = sortedMetrics[0];
    const raceethnicity = indicators?.find(i => i.id === 1228);
    const age = indicators?.find(i => i.id === 1230);

    if (!indicators || indicators.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <>
            <div className="grid grid-cols-2 xxs:grid-cols-3 gap-4 place-items-start">
                {demoOne?.map(metric => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}
                        width="w-full"
                        svg={getSvgMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                ))}
            </div>

            {age &&
                <div className="w-full my-4">
                    <ChartHeader
                        key={age.id}
                        id={age.id}
                        title={"Population by Age"}
                        svg={getSvgMap(age.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                    <MetricBarChart metric={age} height="h-52" background="bg-transparent"/>
                </div>
            }

            {raceethnicity &&
                <div className="w-full mt-2">
                    <ChartHeader
                        key={raceethnicity.id}
                        id={raceethnicity.id}
                        title={raceethnicity.name}
                        svg={getSvgMap(raceethnicity.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                        selectionActive={selectionActive}
                    />
                    <MetricBarChart metric={raceethnicity} height="h-[20rem]" background="bg-transparent"/>
                </div>
            }
        </>
    );
}

export default DemographicMetrics;